import {
  isInternalMessage,
  isMessageFromCurrentUser,
} from './AudioMessageHelper';

const buildInternalConversationUrl = (accountId, inboxId, conversationId) => {
  const { hostURL = '' } = window.chatwootConfig || {};
  return `${hostURL}/app/accounts/${accountId}/inbox/${inboxId}/conversations/${conversationId}`;
};

export const showInternalDesktopNotification = ({
  message,
  currentUser,
  selectedChatId,
  accountId,
  getConversationById,
}) => {
  if (!message || !currentUser?.id) return;
  if (!('Notification' in window) || Notification.permission !== 'granted') {
    return;
  }
  if (isMessageFromCurrentUser(message, currentUser.id)) return;
  if (selectedChatId === message.conversation_id) return;
  if (!isInternalMessage(message, getConversationById)) return;

  const senderName =
    message.sender?.name || message.sender?.available_name || 'Agente';
  const body =
    message.content?.trim() ||
    (message.attachments?.length ? 'Archivo adjunto' : 'Nuevo mensaje');

  const inboxId = message.conversation?.inbox_id;
  const url =
    accountId && inboxId
      ? buildInternalConversationUrl(
          accountId,
          inboxId,
          message.conversation_id
        )
      : null;

  const desktopNotification = new Notification(senderName, {
    body,
    tag: `internal-conversation-${message.conversation_id}`,
    icon: message.sender?.thumbnail,
  });

  if (url) {
    desktopNotification.onclick = () => {
      window.focus();
      window.location.href = url;
    };
  }
};

export const showInternalNotificationFromInboxEvent = ({
  notification,
  currentUser,
  selectedChatId,
  accountId,
}) => {
  if (!notification || !currentUser?.id) return;
  if (!('Notification' in window) || Notification.permission !== 'granted') {
    return;
  }

  const conversation = notification.primary_actor;
  const isInternal =
    conversation?.additional_attributes?.internal_conversation ||
    conversation?.meta?.internal_conversation;

  if (!isInternal) return;
  if (notification.user?.id !== currentUser.id) return;
  if (selectedChatId === conversation?.id) return;

  const senderName = notification.push_message_title || 'Mensaje interno';
  const body = notification.push_message_body || '';
  const inboxId = conversation?.inbox_id;
  const url =
    accountId && inboxId
      ? buildInternalConversationUrl(accountId, inboxId, conversation.id)
      : null;

  const desktopNotification = new Notification(senderName, {
    body,
    tag: `internal-notification-${notification.id}`,
  });

  if (url) {
    desktopNotification.onclick = () => {
      window.focus();
      window.location.href = url;
    };
  }
};
